<template>
  <div style="height: 100%;">
    <router-view/>
    <van-tabbar v-model="active" style="font-size: 12px">
      <van-tabbar-item icon="home-o" name="home" to="/indibabuydd">INDIBA购买/剩余</van-tabbar-item>
      <van-tabbar-item icon="search" name="home1" to="/indibawdd">INDIBA未到店</van-tabbar-item>
      <van-tabbar-item icon="friends-o" name="home2" to="/indibaxfinfo">INDIBA到店</van-tabbar-item>
      <van-tabbar-item icon="setting-o" name="home3" to="/indibaxfcountinfo">INDIBA消耗</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 'home',
    };
  },
  created() {
    
  },
  methods:{
    
  }
};
</script>


// WEBPACK FOOTER //
// src/page/beauty/indibamanaer.vue